import * as moment from "moment";

var booted = false;
declare const CONFIG: any;


export class Intercom {
    static boot(user, companies) {
        if (CONFIG.intercom.appId === 'development') return;

        try {
            (<any>window).Intercom('boot', {
                app_id: (<any>window).CONFIG.intercom.appId,
                email: user.get('email'),
                user_id: user.get('id'),
                created_at: moment(user.get('created')).unix(),
                name: user.get('name'),
                user_hash: user.get('intercom_identity_verification'),
                companies: companies
            });
            booted = true;
        } catch (e) {
            console.error(e);
        }
    }

    static shutdown() {
        if (!booted) return;

        try {
            (<any>window).Intercom('shutdown');
        } catch (e) {
            console.log(e);
        }
    }

    static trackEvent(event, metadata?) {
        if (!booted) return;

        try {
            (<any>window).Intercom('trackEvent', event, metadata);
        } catch (e) {
            console.error(e);
        }
    }

    static update() {
        if (!booted) return;

        try {
            (<any>window).Intercom('update');
        } catch (e) {
            console.error(e);
        }
    }
};



// WEBPACK FOOTER //
// ./srv/public/js/common/intercom.ts